<script setup lang="ts">

const props = withDefaults(defineProps<{
  modelValue: boolean
  disabled: boolean
  label?: string
}>(), {
  label: '',
  disabled: false
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
}>()

function onChange(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
  emit('change', target.checked)
}
</script>

<template>
  <label
      class="toggle"
      :class="{
      'toggle--checked': modelValue,
      'toggle--disabled': disabled
    }"
  >
    <input
        class="toggle__input"
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        @change="onChange"
    />
    <span v-if="label" class="toggle__label">
      {{ label }}
    </span>
    <span class="toggle__track">
      <span class="toggle__thumb"></span>
    </span>
  </label>
</template>

<style scoped lang="scss">
.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  background: var(--color-bg-secondary);
  padding: 12px 14px;
  border-radius: 14px;

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__input {
    display: none;
  }

  &__track {
    position: relative;
    width: 48px;
    height: 28px;
    border-radius: 9999px;
    background: #d1d5db;
    transition: background 0.25s ease;
    flex-shrink: 0;
  }

  &__thumb {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #ffffff;
    transition: left 0.25s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  &__label {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: var(--color-label);
    background: transparent;
  }
}

.toggle--checked .toggle__track {
  background: #22c55e;
}

.toggle--checked .toggle__thumb {
  left: 23px;
}
</style>